// extracted by mini-css-extract-plugin
module.exports =  {"root":"_0d624b9a27--root--WDkWR","title":"_0d624b9a27--title--ZLSKv"};